import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import Layout from "./components/Layout";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import MiTrabajo from "./pages/MiTrabajo";
import Expedientes from "./pages/Expedientes";
import ExpedienteDetail from "./pages/ExpedienteDetail";
import Aprobaciones from "./pages/Aprobaciones";
import Evidencias from "./pages/Evidencias";
import Documentos from "./pages/Documentos";
import DocsCorp from "./pages/DocsCorp";
import Correo from "./pages/Correo";
import PolizasCorp from "./pages/PolizasCorp";
import Vacaciones from "./pages/Vacaciones";
import ControlCorp from "./pages/ControlCorp";
import ExecutiveSummary from "./pages/ExecutiveSummary";
import DemoCenter from "./pages/DemoCenter";
import Comunicaciones from "./pages/Comunicaciones";
import Actividad from "./pages/Actividad";
import Buscar from "./pages/Buscar";
import Escenarios from "./pages/Escenarios";
import LegalDashboard from "./pages/legal/LegalDashboard";
import Contratos from "./pages/legal/Contratos";
import ContratoDetail from "./pages/legal/ContratoDetail";
import Obligaciones from "./pages/legal/Obligaciones";
import Revisiones from "./pages/legal/Revisiones";
import Comparaciones from "./pages/legal/Comparaciones";
import NdaLoi from "./pages/legal/NdaLoi";
import Firmas from "./pages/legal/Firmas";
import Modelos from "./pages/legal/Modelos";
import Clausulas from "./pages/legal/Clausulas";
import FinDashboard from "./pages/finanzas/FinDashboard";
import Solicitudes from "./pages/finanzas/Solicitudes";
import SolicitudDetail from "./pages/finanzas/SolicitudDetail";
import Ofertas from "./pages/finanzas/Ofertas";
import FinComparaciones from "./pages/finanzas/Comparaciones";
import Ordenes from "./pages/finanzas/Ordenes";
import Recepciones from "./pages/finanzas/Recepciones";
import Facturas from "./pages/finanzas/Facturas";
import FacturaDetail from "./pages/finanzas/FacturaDetail";
import Facturacion from "./pages/finanzas/Facturacion";
import Excepciones from "./pages/finanzas/Excepciones";
import Remesas from "./pages/finanzas/Remesas";
import Proveedores from "./pages/finanzas/Proveedores";
import Presupuesto from "./pages/finanzas/Presupuesto";
import ProyectosDashboard from "./pages/proyectos/ProyectosDashboard";
import Portafolio from "./pages/proyectos/Portafolio";
import Proyectos from "./pages/proyectos/Proyectos";
import ProyectoDetail from "./pages/proyectos/ProyectoDetail";
import Planificacion from "./pages/proyectos/Planificacion";
import Recursos from "./pages/proyectos/Recursos";
import Economia from "./pages/proyectos/Economia";
import Reuniones from "./pages/Reuniones";
import ReunionValidacion from "./pages/ReunionValidacion";
import ReunionActa from "./pages/ReunionActa";
import ReunionActaPortal from "./pages/ReunionActaPortal";
import ReunionSeguimiento from "./pages/ReunionSeguimiento";
import ReunionesDashboard from "./pages/ReunionesDashboard";
import Riesgos from "./pages/proyectos/Riesgos";
import Calidad from "./pages/proyectos/Calidad";
import Permisos from "./pages/proyectos/Permisos";
import Acometidas from "./pages/proyectos/Acometidas";
import Seguridad from "./pages/proyectos/Seguridad";
import Reporting from "./pages/proyectos/Reporting";

function FullLoader() {
  return (
    <div className="flex h-screen items-center justify-center bg-background" data-testid="app-loading">
      <div className="flex flex-col items-center gap-3">
        <div className="h-8 w-8 animate-spin rounded-full border-2 border-slate-300 border-t-blue-700" />
        <p className="text-sm text-slate-500">Cargando Tech Stone Workspace…</p>
      </div>
    </div>
  );
}

function Protected({ children }) {
  const { user } = useAuth();
  if (user === undefined) return <FullLoader />;
  if (!user) return <Navigate to="/login" replace />;
  return <Layout>{children}</Layout>;
}

function AppRoutes() {
  const { user } = useAuth();
  return (
    <Routes>
      <Route path="/login" element={user ? <Navigate to="/" replace /> : <Login />} />
      <Route path="/" element={<Protected><Dashboard /></Protected>} />
      <Route path="/mi-trabajo" element={<Protected><MiTrabajo /></Protected>} />
      <Route path="/expedientes" element={<Protected><Expedientes /></Protected>} />
      <Route path="/expedientes/:id" element={<Protected><ExpedienteDetail /></Protected>} />
      <Route path="/aprobaciones" element={<Protected><Aprobaciones /></Protected>} />
      <Route path="/evidencias" element={<Protected><Evidencias /></Protected>} />
      <Route path="/documentos" element={<Protected><Documentos /></Protected>} />
      <Route path="/documentos/corp" element={<Protected><DocsCorp /></Protected>} />
      <Route path="/correo" element={<Protected><Correo /></Protected>} />
      <Route path="/polizas" element={<Protected><PolizasCorp /></Protected>} />
      <Route path="/vacaciones" element={<Protected><Vacaciones /></Protected>} />
      <Route path="/control-corporativo" element={<Protected><ControlCorp /></Protected>} />
      <Route path="/resumen/:stype/:entityId" element={<Protected><ExecutiveSummary /></Protected>} />
      <Route path="/demo-center" element={<Protected><DemoCenter /></Protected>} />
      <Route path="/comunicaciones" element={<Protected><Comunicaciones /></Protected>} />
      <Route path="/actividad" element={<Protected><Actividad /></Protected>} />
      <Route path="/buscar" element={<Protected><Buscar /></Protected>} />
      <Route path="/escenarios" element={<Protected><Escenarios /></Protected>} />
      <Route path="/legal" element={<Protected><LegalDashboard /></Protected>} />
      <Route path="/legal/contratos" element={<Protected><Contratos /></Protected>} />
      <Route path="/legal/contratos/:id" element={<Protected><ContratoDetail /></Protected>} />
      <Route path="/legal/obligaciones" element={<Protected><Obligaciones /></Protected>} />
      <Route path="/legal/revisiones" element={<Protected><Revisiones /></Protected>} />
      <Route path="/legal/comparaciones" element={<Protected><Comparaciones /></Protected>} />
      <Route path="/legal/comparaciones/:id" element={<Protected><Comparaciones /></Protected>} />
      <Route path="/legal/nda-loi" element={<Protected><NdaLoi /></Protected>} />
      <Route path="/legal/firmas" element={<Protected><Firmas /></Protected>} />
      <Route path="/legal/modelos" element={<Protected><Modelos /></Protected>} />
      <Route path="/legal/clausulas" element={<Protected><Clausulas /></Protected>} />
      <Route path="/finanzas" element={<Protected><FinDashboard /></Protected>} />
      <Route path="/finanzas/solicitudes" element={<Protected><Solicitudes /></Protected>} />
      <Route path="/finanzas/solicitudes/:id" element={<Protected><SolicitudDetail /></Protected>} />
      <Route path="/finanzas/ofertas" element={<Protected><Ofertas /></Protected>} />
      <Route path="/finanzas/comparaciones" element={<Protected><FinComparaciones /></Protected>} />
      <Route path="/finanzas/comparaciones/:id" element={<Protected><FinComparaciones /></Protected>} />
      <Route path="/finanzas/ordenes" element={<Protected><Ordenes /></Protected>} />
      <Route path="/finanzas/ordenes/:id" element={<Protected><Ordenes /></Protected>} />
      <Route path="/finanzas/recepciones" element={<Protected><Recepciones /></Protected>} />
      <Route path="/finanzas/facturas" element={<Protected><Facturas /></Protected>} />
      <Route path="/finanzas/facturas/:id" element={<Protected><FacturaDetail /></Protected>} />
      <Route path="/finanzas/facturacion" element={<Protected><Facturacion /></Protected>} />
      <Route path="/finanzas/excepciones" element={<Protected><Excepciones /></Protected>} />
      <Route path="/finanzas/remesas" element={<Protected><Remesas /></Protected>} />
      <Route path="/finanzas/proveedores" element={<Protected><Proveedores /></Protected>} />
      <Route path="/finanzas/presupuesto" element={<Protected><Presupuesto /></Protected>} />
      <Route path="/proyectos" element={<Protected><ProyectosDashboard /></Protected>} />
      <Route path="/proyectos/portafolio" element={<Protected><Portafolio /></Protected>} />
      <Route path="/proyectos/lista" element={<Protected><Proyectos /></Protected>} />
      <Route path="/proyectos/:id" element={<Protected><ProyectoDetail /></Protected>} />
      <Route path="/proyectos/planificacion" element={<Protected><Planificacion /></Protected>} />
      <Route path="/proyectos/recursos" element={<Protected><Recursos /></Protected>} />
      <Route path="/proyectos/economia" element={<Protected><Economia /></Protected>} />
      <Route path="/proyectos/riesgos" element={<Protected><Riesgos /></Protected>} />
      <Route path="/proyectos/calidad" element={<Protected><Calidad /></Protected>} />
      <Route path="/proyectos/permisos" element={<Protected><Permisos /></Protected>} />
      <Route path="/proyectos/acometidas" element={<Protected><Acometidas /></Protected>} />
      <Route path="/proyectos/seguridad" element={<Protected><Seguridad /></Protected>} />
      <Route path="/proyectos/reporting" element={<Protected><Reporting /></Protected>} />
      <Route path="/reuniones" element={<Protected><Reuniones /></Protected>} />
      <Route path="/reuniones/:mid/validacion" element={<Protected><ReunionValidacion /></Protected>} />
      <Route path="/reuniones/cuadro-de-mando" element={<Protected><ReunionesDashboard /></Protected>} />
      <Route path="/reuniones/:mid/seguimiento" element={<Protected><ReunionSeguimiento /></Protected>} />
      <Route path="/reuniones/:mid/acta" element={<Protected><ReunionActa /></Protected>} />
      <Route path="/reuniones/:mid/acta/portal" element={<Protected><ReunionActaPortal /></Protected>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRoutes />
        <Toaster position="bottom-right" richColors />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
